export function getCommerceParametersInitialState() {
    return {};
}
